var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#upload_svg__clip0_16859_131858)",
    fill: "#7D888E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 20H3c-1.65 0-3-1.35-3-3v-4c0-.55.45-1 1-1s1 .45 1 1v4c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4c0 1.65-1.35 3-3 3ZM15 7c-.26 0-.51-.1-.71-.29L10 2.41l-4.29 4.3A.996.996 0 1 1 4.3 5.3l5-5a.996.996 0 0 1 1.41 0l5 5c.39.39.39 1.02 0 1.41-.2.19-.45.29-.71.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 14c-.55 0-1-.45-1-1V1c0-.55.45-1 1-1s1 .45 1 1v12c0 .55-.45 1-1 1Z"
  }))));
};
export default SvgUpload;